import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-cream-2 hair-top">
      <div className="max-w-[1400px] mx-auto container-x py-14 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <p className="font-display text-2xl lg:text-3xl tracking-tight text-ink">
              We Gotta <span className="italic text-gold-bright">Gift</span>
            </p>
            <p className="mt-3 text-[11px] tracking-[0.05em] text-muted-ink max-w-sm">
              A book and podcast capturing the real stories behind the PPAI 100.
              Vol. I, 2026/27 cohort applications open now.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="text-[10px] tracking-[0.22em] text-muted-ink uppercase font-medium mb-4">Published by</p>
            <p className="text-[14px] leading-[1.6] text-ink-soft">
              Consortium Gifts
              <br />
              IGC Global Promotions
              <br />
              Gaurav Bhagat Academy
            </p>
          </div>

          <div className="lg:col-span-4">
            <p className="text-[10px] tracking-[0.22em] text-muted-ink uppercase font-medium mb-4">Contact</p>
            <p className="text-[14px] leading-[1.6] text-ink-soft">
              <a className="lnk" href="mailto:editorial@wegottagift.com" data-testid="footer-contact">
                editorial@wegottagift.com
              </a>
            </p>
            <div className="mt-5 flex flex-wrap gap-4 text-[11px] tracking-[0.18em] uppercase font-medium text-ink-soft">
              <a className="lnk" href="#privacy" data-testid="footer-privacy">Privacy</a>
              <a className="lnk" href="#terms" data-testid="footer-terms">Terms</a>
              <a className="lnk" href="#press" data-testid="footer-press">Press</a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 hair-top flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[10px] tracking-[0.18em] text-muted-ink uppercase">
          <p>© {year} We Gotta Gift · Vol. I edition.</p>
          <p>Applications close once the 60-slot cohort fills.</p>
        </div>
      </div>
    </footer>
  );
}
